import { type UseQueryResult, useQuery } from 'react-query';
import { PerformanceRuleService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetPerformanceRuleTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const PerformanceRuleTypes = useQuery(
    ['getPerformanceRuleTypes'],
    async () => {
      return await handleRequest(
        PerformanceRuleService.getApiAwardApiAppPerformanceRulePerformanceRuleTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return PerformanceRuleTypes;
};

export default useGetPerformanceRuleTypes;
